import { Swiper } from 'swiper';
import { A11y, Autoplay } from 'swiper/modules';
import afterPaint from '../../../js/__utils/afterPaint';

const sliders = document.querySelectorAll('.block-logo-carousel .swiper');

if (sliders.length > 0) {
	const intialUrl = new URL(window.location);
	const backstop = intialUrl.searchParams.get('backstop');

	sliders.forEach((slider) => {
		const slides = slider.querySelectorAll('.swiper-slide');

		const settings = {
			loop: slides.length > 2 ? true : false,
			spaceBetween: 64, // Ensures 64px gap between slides
			slidesPerView: 'auto',
			modules: [A11y, Autoplay],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			speed: 4000,
			autoplay: {
				delay: 0,
			},
			breakpoints: {
				448: {
					spaceBetween: 32,
				},
				576: {
					spaceBetween: 32,
				},
				768: {
					spaceBetween: 32,
				},
				992: {
					spaceBetween: 64,
				},
			},
		};

		if (backstop) {
			settings.autoplay = false;
		}

		afterPaint(() => {
			new Swiper(slider, settings);
		});
	});
}
